
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Von einem einzelnen heissen und trockenen Sommer kann sich der Wald erholen,
wenn die nächsten Jahre wieder normale Bedingungen herrschen. Das zeigt die
Entwicklung nach 2003. Gibt es aber in mehreren aufeinanderfolgenden Saisons
wenig Niederschlag und hohe Temperaturen, wird es kritisch. «Die beiden Sommer
2018 und 2019 hatten einen deutlichen negativen Einfluss. Die Wälder sind
angeschlagen», sagt Buras.`}</p>
    <p>{`Diesen Eindruck teilt auch Arthur Gessler von der Eidgenössischen
Forschungsanstalt für Wald, Schnee und Landschaft (WSL) in Birmensdorf: «Lokal
haben die Schäden an Bäumen zugenommen.» Zwar gebe es noch keine klare Tendenz,
dass sich die Vitalität in der ganzen Schweiz verschlechtere. «Aber die
Extremjahre häufen sich, der Stress für den Wald nimmt zu», sagt Gessler.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;